// snackbarSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  messages: [
    // key: orderId,
    // message: message,
    // severity: severity,
  ],
};

const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    enqueueSnackbar: (state, action) => {
      state.messages.push(action.payload);
    },
    closeSnackbar: (state, action) => {
      state.messages = state.messages.filter(
        (msg) => msg.key !== action.payload.key
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const { enqueueSnackbar, closeSnackbar } = snackbarSlice.actions;

export default snackbarSlice.reducer;
